export default {
  SERVICE_SCORE: [{
    id: 0,
    name: ''
  }, {
    id: 1,
    name: '差'
  }, {
    id: 2,
    name: '中'
  }, {
    id: 3,
    name: '好'
  }],
  INVOICE_HANDOVER_TYPE: [{
    id: 1,
    name: '面对面',
    disabled: false
  }, {
    id: 2,
    name: '快递',
    disabled: false
  }, {
    id: 3,
    name: '邮箱',
    disabled: false
  }],
  INVOICE_TYPE: [{
    id: 1,
    name: '纸质专票'
  }, {
    id: 2,
    name: '纸质普票'
  }, {
    id: 3,
    name: '电子发票'
  }],
  INVOICE_STATUS: [{
    id: 1,
    name: '待开票'
  }, {
    id: 2,
    name: '待交接'
  }, {
    id: 3,
    name: '已交接'
  }],
  FILE_TYPE_LIST: [{
    id: 1,
    name: '上月完税'
  }, {
    id: 2,
    name: '本月收入票'
  }, {
    id: 3,
    name: '银行收付'
  }, {
    id: 4,
    name: '成本费用票'
  }, {
    id: 5,
    name: '辅助资料'
  }],
  // 是否
  YES_NO: [{
    id: 1,
    name: '是',
    color: 'success'
  }, {
    id: 2,
    name: '否',
    color: 'info'
  }],
  UPLOAD: {
    IMAGE_TYPES: ['jpg', 'png', 'jpeg', 'bmp'],
    IMG_WIDTH_LIMIT: 1024,
    IMG_HEIGHT_LIMIT: 1024
  },
  /**
   * 基础
   * */
  TIP: {
    TITLE: '系统提示',
    SELECT_ONE_FIRST: '请您选择一项，再进行操作',
    SELECT_ONE_LEAST: '请您至少选择一项，再进行操作',
    NO_OPERATION_RECORDS: '无可操作的数据',
    EMPTY_MSG: '暂无数据',
    VISIT_ERROR_MSG: '请您在微信端访问',
    NOT_BIND_MSG: '请您先绑定您的企业',
  },
  // 分页信息
  PAGINATION: {
    TOTAL: 0,
    PAGE: 1,
    ROWS: 50,
    MAX_ROWS: 99999999
  },
  // 默认小数保留位
  DECIMAL: {
    DEFAULT_PRECISION: 2,
    DEFAULT_SPEC_PRECISION: 4,
    DEFAULT_MAX_NUM: 9999999.99,
    DEFAULT_SPEC_MAX_NUM: 9999999.9999
  },
  SEND_SMS_INTERVAL: 60, // 获取短信时间间隔（s）
  CX_USER: 'chunxue',
  USER_KEY: 'Workbench-Mobile-User-Key',
  DEFAULT_TOKEN: 'ADMIN_TOKEN',
  COMPANY_NAME: '北京春雪'
}



// WEBPACK FOOTER //
// ./src/utils/const.js